import React, { useEffect } from "react";
import CardPresentational from "../../../Presentational/CardPresentational";

const StatusTrapCard = ({ cardValue, cardText }) => {
  return <CardPresentational number={cardValue} text={cardText} />;
};

export default StatusTrapCard;
